import styled from 'styled-components';
import { propsMap } from '@/presentation/interfaces';
import { sizes, weights, letterSpacings, lineHeights } from './Text.constants';

export interface ITextProps {
  id?: string;
  color?: string;
  size?: 'xxxs' | 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
  weight?: string;
  italic?: boolean;
  align?: 'center' | 'left' | 'right' | 'justify';
}

const Text = styled.p<ITextProps>`
  color: ${({ color, theme }) => color ?? theme.colors.primaryText};
  font-family: ${({ weight, theme }) => (weight ? (theme.fonts as propsMap)[weight] : theme.fonts.regular)};
  font-size: ${({ size }) => (size ? sizes[size] : sizes.s)};
  font-weight: ${({ weight }) => (weight ? weights[weight] : weights.regular)};
  letter-spacing: ${({ size }) => (size ? letterSpacings[size] : letterSpacings.s)};
  line-height: ${({ size }) => (size ? lineHeights[size] : lineHeights.s)};
  margin: 0;
  text-align: ${({ align }) => (align ? align : '')};
  ${({ italic }) => italic && `font-style: italic;`}

  &.disabled {
    opacity: 0.5;
  }
`;

export default Text;
